import type { AxiosError, AxiosInstance } from "axios";
import axios from "axios";

const api: AxiosInstance = axios.create();

api.interceptors.request.use(
  (config) => {
    const token = import.meta.env.VITE_API_TOKEN || "8f3c7e12-4b9d-4e56-a123-9876543210ab";
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

export default api;
